// extracted by mini-css-extract-plugin
module.exports = {"locale":"_1txo9","link":"_1qNle","active":"_1iN4s"};